var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M14.4001 8.0001L11.2001 11.4668M14.4001 8.0001L11.2001 4.8001M14.4001 8.0001L4.26676 8.0001M8.53343 14.4001H1.6001L1.6001 1.6001L8.53343 1.6001",
      stroke: "#484848"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }